<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-book"
  >
    <g fill-rule="evenodd">
      <g
        transform="translate(-564.000000, -470.000000)"
        class="fill"
      >
        <g transform="translate(564.000000, 470.000000)">
          <path
            d="M6.37499925,22 C4.99666547,22 3.87499925,20.8783258 3.87499925,19.5 L3.87499925,5.12499875 C3.87499925,3.40166611 5.27666536,2 6.999998,2 L18.8749992,2 C19.5641596,2 20.1249927,2.56083311 20.1249927,3.2499995 L20.1249927,17 C20.1249927,17.6891604 19.5641596,18.2499935 18.8749992,18.2499935 L18.8749992,20.7499925 L19.499993,20.7499925 C19.8449929,20.7499925 20.1249927,21.0299924 20.1249927,21.3749922 C20.1249927,21.7199921 19.8449929,22 19.499993,22 L6.37499925,22 Z M6.37499825,18.2499935 C5.68583186,18.2499935 5.12499875,18.8108266 5.12499875,19.499993 C5.12499875,20.1891594 5.68583186,20.7499935 6.37499825,20.7499935 L17.6249987,20.7499935 L17.6249987,18.2499935 L6.37499825,18.2499935 Z M6.999998,3.2499995 C5.96583175,3.2499995 5.12499875,4.0908325 5.12499875,5.12499875 L5.12499875,17.3341605 C5.50083193,17.1158273 5.92833176,16.999994 6.37499825,16.999994 L18.8749932,16.999994 L18.8749932,3.2499995 L6.999998,3.2499995 Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
